import React, { useEffect, useState } from 'react';
import { FiCalendar, FiClock, FiPlus, FiTrash2 } from 'react-icons/fi';

const emptyEvent = { title: '', description: '', date: '', time: '', color: '#2f7690' };

const EditCalendar = () => {
  const [events, setEvents] = useState([]);
  const [newEvent, setNewEvent] = useState(emptyEvent);
  const [status, setStatus] = useState('');

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await fetch('https://us-central1-indian-park.cloudfunctions.net/getCalendarEvents');
        const data = await res.json();
        setEvents(data || []);
      } catch (error) {
        console.error('Unable to load calendar events', error);
        setStatus('Unable to load calendar events.');
      }
    };
    fetchEvents();
  }, []);

  const saveEvents = async (updatedEvents, successMessage) => {
    const res = await fetch('https://us-central1-indian-park.cloudfunctions.net/saveCalendarEvents', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatedEvents),
    });
    if (!res.ok) throw new Error('Failed to save calendar events');
    setStatus(successMessage);
  };

  const handleAddEvent = async () => {
    if (!newEvent.title.trim() || !newEvent.date || !newEvent.time) {
      setStatus('Add a title, date, and time before saving.');
      return;
    }
    const updatedEvents = [...events, newEvent];
    setEvents(updatedEvents);
    setNewEvent(emptyEvent);
    setStatus('Saving…');
    try {
      await saveEvents(updatedEvents, 'Event added to the public calendar.');
    } catch (error) {
      console.error(error);
      setStatus('The event could not be saved. Please try again.');
    }
  };

  const handleDelete = async (originalIndex) => {
    const updatedEvents = events.filter((_, index) => index !== originalIndex);
    setEvents(updatedEvents);
    setStatus('Saving…');
    try {
      await saveEvents(updatedEvents, 'Event removed from the public calendar.');
    } catch (error) {
      console.error(error);
      setStatus('The event could not be removed. Please try again.');
    }
  };

  const sortedEvents = events
    .map((event, originalIndex) => ({ ...event, originalIndex }))
    .sort((a, b) => new Date(`${a.date}T${a.time || '00:00'}`) - new Date(`${b.date}T${b.time || '00:00'}`));

  return (
    <div className="admin-two-column calendar-admin-grid">
      <section className="dash-card form-card">
        <div className="dash-card-heading">
          <div><span className="dash-card-label">New event</span><h2>Add to the calendar</h2></div>
          <FiCalendar />
        </div>
        <div className="form-grid">
          <label className="full-field">Event title<input placeholder="Community meeting" value={newEvent.title} onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })} /></label>
          <label className="full-field">Description<textarea placeholder="Add helpful details for residents" value={newEvent.description} onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })} /></label>
          <label>Date<input type="date" value={newEvent.date} onChange={(e) => setNewEvent({ ...newEvent, date: e.target.value })} /></label>
          <label>Time<input type="time" value={newEvent.time} onChange={(e) => setNewEvent({ ...newEvent, time: e.target.value })} /></label>
          <label className="full-field color-field compact"><span>Event color</span><input type="color" value={newEvent.color} onChange={(e) => setNewEvent({ ...newEvent, color: e.target.value })} /></label>
        </div>
        <div className="form-actions">
          <button className="primary-button" onClick={handleAddEvent}><FiPlus /> Add event</button>
          {status && <span className="save-status" role="status">{status}</span>}
        </div>
      </section>

      <section className="dash-card event-list-card">
        <div className="dash-card-heading">
          <div><span className="dash-card-label">Live calendar</span><h2>Scheduled events</h2></div>
          <span className="count-badge">{events.length}</span>
        </div>
        <div className="event-list">
          {sortedEvents.length ? sortedEvents.map((event) => (
            <article className="event-row" key={`${event.originalIndex}-${event.date}-${event.time}`} style={{ '--event-color': event.color }}>
              <div className="event-date"><strong>{new Date(`${event.date}T12:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</strong><span>{new Date(`${event.date}T12:00:00`).getFullYear()}</span></div>
              <div className="event-details"><strong>{event.title}</strong><span><FiClock /> {event.time || 'Time not set'}</span>{event.description && <p>{event.description}</p>}</div>
              <button className="icon-button danger" onClick={() => handleDelete(event.originalIndex)} aria-label={`Delete ${event.title}`}><FiTrash2 /></button>
            </article>
          )) : <div className="list-empty">No events are currently scheduled.</div>}
        </div>
      </section>
    </div>
  );
};

export default EditCalendar;
